/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Select_Folder_TitleInputs */

const en_audio_description_export_select_folder_title = /** @type {(inputs: Audio_Description_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Audio Description - Select Folder`)
};

const fr_audio_description_export_select_folder_title = /** @type {(inputs: Audio_Description_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter la description audio - sélectionner un dossier`)
};

const de_audio_description_export_select_folder_title = /** @type {(inputs: Audio_Description_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobeschreibung exportieren – Ordner auswählen`)
};

const it_audio_description_export_select_folder_title = /** @type {(inputs: Audio_Description_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta descrizione audio - Seleziona cartella`)
};

const ru_audio_description_export_select_folder_title = /** @type {(inputs: Audio_Description_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт аудиоописания - Выберите папку`)
};

const es_audio_description_export_select_folder_title = /** @type {(inputs: Audio_Description_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar descripción de audio - Seleccionar carpeta`)
};

const zh_cn2_audio_description_export_select_folder_title = /** @type {(inputs: Audio_Description_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出音频描述 - 选择文件夹`)
};

const ja_audio_description_export_select_folder_title = /** @type {(inputs: Audio_Description_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声説明のエクスポート - フォルダの選択`)
};

const hi_audio_description_export_select_folder_title = /** @type {(inputs: Audio_Description_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण निर्यात करें - फ़ोल्डर चुनें`)
};

const pt_pt2_audio_description_export_select_folder_title = /** @type {(inputs: Audio_Description_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar descrição de áudio - Selecionar pasta`)
};

/**
* | output |
* | --- |
* | "Export Audio Description - Select Folder" |
*
* @param {Audio_Description_Export_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_select_folder_title = /** @type {((inputs?: Audio_Description_Export_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_select_folder_title(inputs)
	if (locale === "de") return de_audio_description_export_select_folder_title(inputs)
	if (locale === "it") return it_audio_description_export_select_folder_title(inputs)
	if (locale === "ru") return ru_audio_description_export_select_folder_title(inputs)
	if (locale === "es") return es_audio_description_export_select_folder_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_select_folder_title(inputs)
	if (locale === "ja") return ja_audio_description_export_select_folder_title(inputs)
	if (locale === "hi") return hi_audio_description_export_select_folder_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_select_folder_title(inputs)
	return en_audio_description_export_select_folder_title(inputs)
});